import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SingleImage } from "@faire/retailer-visitor-shared/features/Showroom/ApparelCategory/SingleImage";
import { useMilestone, useRecordMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import trackClick from "@faire/web-api--source/api/click-track/post";
import { trackApparelDiscoveryShowroomV2Click } from "@faire/web-api--source/events/apparelDiscovery/click/showroomV2";
import { trackApparelDiscoveryShowroomV2View } from "@faire/web-api--source/events/apparelDiscovery/view/showroomV2";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import { SHOWROOM_APPAREL_C2_TITLE_BANNER } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SHOWROOM_APPAREL_C2_TITLE_BANNER";
import { SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED";
import React, { useCallback, useState } from "react";
import styled, { css } from "styled-components";
var IMAGE_GAP = 4;
var LEFT_IMAGE = {
    width: 144,
    height: 192
};
var RIGHT_IMAGE = {
    width: 156,
    height: 192
};
export var ShowroomTitleBanner = function(param) {
    var layoutElement = param.layoutElement, className = param.className, isLoggedOutPage = param.isLoggedOutPage, requestId = param.requestId, category = param.category;
    var isMobile = useViewport().isMobile;
    var _useMilestone = useMilestone(SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED), hasShowroomApparelC2TitleBannerDismissed = _useMilestone.hasOccurred, recordShowroomApparelC2TitleBannerDismissed = _useMilestone.incrementCount;
    var recordMilestone = useRecordMilestone();
    var _useState = _sliced_to_array(useState(200), 2), expectedContainerHeight = _useState[0], setExpectedContainerHeight = _useState[1];
    var eventName = "".concat(layoutElement.type, "-").concat(category === null || category === void 0 ? void 0 : category.mostSpecificPathIdentifier);
    var measuredRef = useCallback(function(node) {
        if (node !== null) {
            setExpectedContainerHeight(node.clientHeight);
        }
    }, []);
    var onVisible = function() {
        recordMilestone(SHOWROOM_APPAREL_C2_TITLE_BANNER);
        trackApparelDiscoveryShowroomV2View(eventName, requestId !== null && requestId !== void 0 ? requestId : "", "");
    };
    var ref = useDoActionWhenVisible(onVisible);
    var onClose = function() {
        recordShowroomApparelC2TitleBannerDismissed();
        trackApparelDiscoveryShowroomV2Click(eventName, "dismissed", requestId !== null && requestId !== void 0 ? requestId : "");
    };
    var onClick = function() {
        var linkToCategoryPathId = layoutElement.category_path_identifier;
        trackApparelDiscoveryShowroomV2Click(eventName, linkToCategoryPathId !== null && linkToCategoryPathId !== void 0 ? linkToCategoryPathId : "", requestId !== null && requestId !== void 0 ? requestId : "");
        if (linkToCategoryPathId) {
            trackClick(IClickInfo.build({
                token: linkToCategoryPathId,
                request_id: requestId,
                type: IClickInfo.Type.CATEGORY,
                container_name: eventName
            }));
        }
    };
    if (hasShowroomApparelC2TitleBannerDismissed) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        ref: ref,
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            $hideMarginBottom: isLoggedOutPage,
            children: [
                /*#__PURE__*/ _jsxs(LeftWrapper, {
                    ref: measuredRef,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraphSansRegular",
                            color: Core.text.inverse,
                            children: layoutElement.description_text
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: {
                                mobileAndAbove: "displaySSerifRegular",
                                desktopAndAbove: "displayMSerifRegular"
                            },
                            color: Core.text.inverse,
                            children: layoutElement.main_text
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: {
                                mobileAndAbove: "2x",
                                tabletAndAbove: "1x"
                            }
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ _jsx(StyledButton, {
                                    variant: "tertiary",
                                    linkTo: layoutElement.cta_link,
                                    onClick: onClick,
                                    children: layoutElement.cta_text
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    size: "1x"
                                }),
                                /*#__PURE__*/ _jsx(Arrow, {
                                    direction: "right",
                                    color: Core.icon.inverse
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(ImageContainer, {
                    images: layoutElement.images,
                    isMobile: isMobile,
                    expectedContainerHeight: expectedContainerHeight
                }),
                isLoggedOutPage ? null : /*#__PURE__*/ _jsx(CloseWrapper, {
                    onClick: onClose,
                    children: /*#__PURE__*/ _jsx(Close, {
                        color: Core.icon.inverse
                    })
                })
            ]
        })
    });
};
var ImageContainer = function(param) {
    var images = param.images, isMobile = param.isMobile, expectedContainerHeight = param.expectedContainerHeight;
    if (isMobile || images.length !== 4) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(ImageWrapper, {
                "data-test-id": "image-wrapper",
                children: [
                    images[0] === undefined ? null : /*#__PURE__*/ _jsx(SingleImage, {
                        image: images[0],
                        imageRatio: LEFT_IMAGE.width / LEFT_IMAGE.height,
                        imageHeight: expectedContainerHeight - IMAGE_GAP * 2
                    }, "showroom-banner-image-left"),
                    /*#__PURE__*/ _jsx(ImageColumnWrapper, {
                        children: images.slice(1, 3).map(function(image, index) {
                            return /*#__PURE__*/ _jsx(SingleImage, {
                                image: image,
                                imageRatio: 1,
                                imageHeight: (expectedContainerHeight - IMAGE_GAP * 3) / 2
                            }, "showroom-banner-image-middle-".concat(index));
                        })
                    }),
                    images[3] === undefined ? null : /*#__PURE__*/ _jsx(SingleImage, {
                        image: images[3],
                        imageRatio: RIGHT_IMAGE.width / RIGHT_IMAGE.height,
                        imageHeight: expectedContainerHeight - IMAGE_GAP * 2
                    }, "showroom-banner-image-right")
                ]
            }),
            /*#__PURE__*/ _jsx(DarkOverlay, {})
        ]
    });
};
var Wrapper = styled(Row).attrs({
    align: "center",
    justify: "space-between"
}).withConfig({
    componentId: "sc-5b003212-0"
})([
    "background-color:",
    ";width:100%;position:relative;overflow:hidden;",
    " ",
    "{padding:",
    ";",
    "}"
], Core.surface.enabled, function(param) {
    var $hideMarginBottom = param.$hideMarginBottom;
    return $hideMarginBottom ? "" : css([
        "margin-bottom:",
        ";"
    ], getSpacing("4x"));
}, responsiveMediaQueries.mobile, getSpacing("3x", 40, "3x", "5x"), function(param) {
    var $hideMarginBottom = param.$hideMarginBottom;
    return $hideMarginBottom ? "" : css([
        "margin-bottom:",
        ";"
    ], getSpacing("2x"));
});
var LeftWrapper = styled(Column).attrs({
    justify: "center"
}).withConfig({
    componentId: "sc-5b003212-1"
})([
    "width:100%;min-height:200px;",
    "{padding:",
    ";width:fit-content;}"
], responsiveMediaQueries.tabletAndAbove, getSpacing(26, 32));
var ImageWrapper = styled(Row).withConfig({
    componentId: "sc-5b003212-2"
})([
    "padding:",
    ";"
], getSpacing(IMAGE_GAP, 0));
var ImageColumnWrapper = styled(Column).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-5b003212-3"
})([
    "padding:",
    ";"
], getSpacing(0, IMAGE_GAP));
var DarkOverlay = styled.div.withConfig({
    componentId: "sc-5b003212-4"
})([
    "width:238px;height:100%;background:linear-gradient( 270deg,",
    " 0%,rgba(0,0,0,0) 88.01% );position:absolute;right:0;top:0;pointer-events:none;"
], Core.surface.enabled);
var StyledButton = styled(Button).withConfig({
    componentId: "sc-5b003212-5"
})([
    "text-decoration-color:",
    ";color:",
    ";width:fit-content;&:hover,&:active,&:focus{text-decoration-color:",
    ";color:",
    ';}position:unset;&:before{content:" ";position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;}'
], Core.text.inverse, Core.text.inverse, Core.text.inverse, Core.text.inverse);
var CloseWrapper = styled.div.withConfig({
    componentId: "sc-5b003212-6"
})([
    "position:absolute;top:12px;right:12px;padding:",
    ";cursor:pointer;z-index:2;"
], getSpacing("1x"));
